import { render, staticRenderFns } from "./rateType.vue?vue&type=template&id=2f2ea6ab"
import script from "./rateType.vue?vue&type=script&lang=js"
export * from "./rateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports